import { jsx as _jsx, jsxs as _jsxs } from "@redneckz/uni-jsx/jsx-runtime";
import { JSX } from '@redneckz/uni-jsx';
import { style } from '../../utils/style.js';
import { renderBenefitIcon } from './renderBenefitIcon.js';
import { renderBenefitText } from './renderBenefitText.js';
export const BenefitItem = JSX(({ className, benefitsVersion, ..._ }) => (_jsxs("div", { className: style('flex gap-m min-w-56 items-center', className), role: "listitem", children: ['icon' in _ ? renderBenefitIcon(_.icon, benefitsVersion) : null, _jsx("div", { children: renderBenefitText(_) })] })));
//# sourceMappingURL=BenefitItem.js.map